import { useContext, useEffect, useMemo } from 'react';
import { parse } from 'query-string';
import { bookingState } from '../client-state/booking-state-context';
import Duration from '../../../ui-components/Duration';
import useBookingTracking from '../../../Hooks/useBookingTracking';
import { bookingActionTypes } from '../client-state/reducers/bookingReducer';
import useBookingMinimalShops from '../server-data/use-booking-minimal-shops';
import useBookingMinimalShop from '../server-data/use-booking-minimal-shop';
import { getDurationNumber } from '../../../Utils/utils';

const initialDuration = Number(parse(window.location.search).duration);

const DurationWithData = () => {
  const { isFetching: isFetchingShops } = useBookingMinimalShops();
  const { data: minimalShop, isFetching: isFecthingShop } = useBookingMinimalShop();
  const { state, dispatch } = useContext(bookingState);
  const track = useBookingTracking();

  useEffect(() => {
    if (minimalShop?.defaultDuration && !initialDuration) {
      console.log(
        'dispatching UPDATE_DURATION, default duration:',
        minimalShop.defaultDuration
      );
      dispatch({
        type: bookingActionTypes.UPDATE_DURATION,
        payload: getDurationNumber(minimalShop.defaultDuration),
      });
    }
  }, [dispatch, minimalShop?.defaultDuration]);

  const durationOptions = useMemo(() => {
    if (!minimalShop?.durationOptions) return [];

    return minimalShop.durationOptions.sort(
      (a, b) => a.durationNumber - b.durationNumber
    );
  }, [minimalShop?.durationOptions]);

  return (
    <Duration
      duration={state.booking.duration}
      durationOptions={durationOptions}
      boatCount={state.booking.boatCount}
      onChange={(duration) => {
        dispatch({ type: bookingActionTypes.UPDATE_DURATION, payload: duration });
        track({ type: 'CHANGE_DURATION', duration: duration });
      }}
      error={state.errors.duration ?? undefined}
      loading={isFetchingShops || isFecthingShop}
    />
  );
};

export default DurationWithData;
